import React, { useState, useEffect } from "react";
import Container from 'react-bootstrap/Container';
import Nav from 'react-bootstrap/Nav';
import Navbar from 'react-bootstrap/Navbar';

function NavbarItem() {
    const [isScrolled, setIsScrolled] = useState(false);
    const [expanded, setExpanded] = useState(false);

    const handleToggle = () => {
        setExpanded(!expanded);
    };

    useEffect(() => {
        const handleScroll = () => {
            // Vérifie si la page est scrollée
            setIsScrolled(window.scrollY > 0);
        };

        window.addEventListener("scroll", handleScroll);
        return () => {
            window.removeEventListener("scroll", handleScroll);
        };
    }, []);

    return (
        <Navbar fixed="top"  expand="lg" bg="" className={`custom-navbar ${isScrolled ? "navbar-blurred" : "default-navbar"}`}>
            <Container>
                <Navbar.Toggle
                    aria-controls="navbar-nav"
                    onClick={handleToggle}
                    className={`custom-toggler ${expanded ? "toggler-open" : "toggler-closed"}`}
                >
                    <span className="bar"></span>
                    <span className="bar"></span>
                    <span className="bar"></span>
                </Navbar.Toggle>
                <Navbar.Collapse id="basic-navbar-nav">
                    <Nav className="me-auto">
                        <Nav.Link href="#about">
                            <div className="nav-item-custom">
                                Moi, en quelques mots
                            </div>
                        </Nav.Link>
                        <Nav.Link href="#portfolio">
                            <div className="nav-item-custom">
                                Mes projets
                            </div>
                        </Nav.Link>
                        <Nav.Link href="#skill">
                            <div className="nav-item-custom">
                                Mes compétences
                            </div>
                        </Nav.Link>
                        <Nav.Link href="#resume">
                            <div className="nav-item-custom">
                                Mes expériences
                            </div>
                        </Nav.Link>
                    </Nav>
                </Navbar.Collapse>
            </Container>
        </Navbar>
    );
}

export default NavbarItem;